import { useMemo, type ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { saveBranchFilterPrefs } from '../widget-lib/embed-user-prefs';

const buttonClass =
  'inline-flex h-9 w-full items-center justify-center rounded-sm border border-[var(--btn-secondary-border)] bg-[var(--btn-secondary-bg)] px-3.5 text-[13px] font-medium text-[var(--btn-secondary-fg)] transition-colors hover:bg-[var(--btn-secondary-bg-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)] sm:w-auto';

const textDefaultClass =
  'inline text-[13px] font-medium text-[var(--accent)] underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)] rounded-sm';

type BranchPickLinkProps = {
  branchId: number;
  children: ReactNode;
  /** `button` — как раньше; `text` — строка-ссылка (имя в карточке филиала). */
  variant?: 'button' | 'text';
  className?: string;
  /** Если задан — сохраняем выбор филиала для фильтров расписания. */
  organizationId?: number | null;
};

/**
 * Выбор филиала через обновление `branch_id` в query (Router Link — надёжнее клика по button на мобильных/в iframe).
 */
export function BranchPickLink({
  branchId,
  children,
  variant = 'button',
  className,
  organizationId,
}: BranchPickLinkProps) {
  const location = useLocation();
  const to = useMemo(() => {
    const next = new URLSearchParams(location.search);
    next.set('branch_id', String(branchId));
    next.delete('all_branches');
    return `${location.pathname}?${next.toString()}`;
  }, [location.pathname, location.search, branchId]);

  const base = variant === 'text' ? textDefaultClass : buttonClass;

  function onClick() {
    if (organizationId != null && organizationId > 0) {
      saveBranchFilterPrefs(organizationId, { branchId, allBranches: false });
    }
  }

  return (
    <Link to={to} replace className={className ? `${base} ${className}` : base} onClick={onClick}>
      {children}
    </Link>
  );
}
